module.exports = __webpack_public_path__ + "img/edifier-logo-gris.7ce63824.svg";